import React from "react";
import { AlertCircle } from "lucide-react";
import Button from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";

interface EmergencyHoursModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const EmergencyHoursModal: React.FC<EmergencyHoursModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                {/* Header */}
                <div className="flex items-center mb-6">
                    <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center mr-3">
                        <AlertCircle className="w-6 h-6 text-white" />
                    </div>
                    <h2 className="text-xl font-bold text-gray-900">{t("emergencyHoursModal.title")}</h2>
                </div>

                {/* Content */}
                <div className="space-y-4">
                    <p className="text-gray-700">
                        {t("emergencyHoursModal.importantMessage")}{" "}
                        <span className="font-bold text-red-600">{t("emergencyHoursModal.emergencyProfessional")}</span>. {t("emergencyHoursModal.thisMeans")}
                    </p>
                    
                    <ul className="space-y-2">
                        <li className="flex items-start">
                            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                            <span className="text-gray-700">{t("emergencyHoursModal.availableForUrgent")}</span>
                        </li>
                        <li className="flex items-start">
                            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                            <span className="text-gray-700">{t("emergencyHoursModal.receiveEmergencyCalls")}</span>
                        </li>
                        <li className="flex items-start">
                            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                            <span className="text-gray-700">{t("emergencyHoursModal.higherPriority")}</span>
                        </li>
                        <li className="flex items-start">
                            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                            <span className="text-gray-700">{t("emergencyHoursModal.specifyServiceZones")}</span>
                        </li>
                    </ul>

                    <p className="text-gray-700 font-medium">
                        {t("emergencyHoursModal.readyToTakeOn")}
                    </p>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        className="px-4 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50"
                    >
                        {t("emergencyHoursModal.cancel")}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white"
                    >
                        {t("emergencyHoursModal.confirmButton")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default EmergencyHoursModal;
